import { useEffect, useState } from "react";
import "./form-analise-ai.component.css";
import {
  Box,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  Typography,
} from "../../../../../components";
import { AIService } from "../../../../../services";
import {
  AnimationFindProdutoAI,
  ErrorProdutoAI,
  ProdutoAI,
} from "./components";
import palette from "../../../../../styles/dark-theme/palette";
import { alpha } from "@mui/material";

export function FormAnaliseAI({
  open,
  setOpen,
  descricaoProduto,
  handleAplicarSugestaoAi,
  gruposTributacao,
}) {
  const steps = [
    "Analisando descrição do produto...",
    "Consultando base de dados fiscais...",
    "Processando com inteligência artificial...",
    "Identificando classificação NCM...",
    "Calculando tributação adequada...",
    "Verificando regras de CFOP...",
    "Validando dados fiscais...",
    "Finalizando sugestão...",
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const [produtoAI, setProdutoAI] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchDescricao, setSearchDescricao] = useState("");

  const aiService = new AIService();

  const buscarProdutoAI = async (body) => {
    try {
      const res = await aiService.invokeAgent("ncm-classifier", body);
      const data = res?.data;
      if (data?.resultado?.conteudoParsed?.resultados?.length) {
        return data.resultado.conteudoParsed.resultados[0];
      }
      return data;
    } catch (err) {
      console.error("Erro ao invocar agente:", err);
      throw err;
    }
  };

  function handleClose() {
    setOpen(false);
    setSearchDescricao("");
  }

  useEffect(() => {
    let timer;
    let isCancelled = false;

    if (open) {
      setSearchDescricao(descricaoProduto || "");
      setCurrentStep(1);
      setProdutoAI(null);
      setError(null);

      if (searchDescricao && searchDescricao.trim()) {
        setLoading(true);

        const body = {
          input: searchDescricao.trim(),
          temperatura: 0.1,
          contexto: {
            uf_origem: "BA",
            uf_destino: "BA",
            tipo_operacao: "venda",
          },
          ragMinScore: 0.7,
          timeoutMs: 10000,
          metadados: {
            origem: "erp-adsoft",
            usuario: "joao.silva",
          },
        };

        const fetchPromise = buscarProdutoAI(body);

        const animationPromise = new Promise((resolve) => {
          let step = 1;
          setCurrentStep(step);
          const intervalMs = 1300;
          timer = setInterval(() => {
            step++;
            setCurrentStep(step);
            if (step > steps.length) {
              clearInterval(timer);
              resolve();
            }
          }, intervalMs);
        });

        Promise.all([fetchPromise, animationPromise])
          .then(([fetched]) => {
            if (isCancelled) return;
            if (fetched) {
              const grupo = gruposTributacao.find(
                (g) => g.csoSimplesNacional === fetched.cso,
              );
              setProdutoAI({
                ...fetched,
                descricao: searchDescricao,
                grupoTributarioId: grupo?.id,
                grupoTributacao: grupo?.nome,
              });
            }
          })
          .catch((err) => {
            if (isCancelled) return;
            setError(err?.message || "Erro ao processar análise");
          })
          .finally(() => {
            if (!isCancelled) setLoading(false);
          });
      }
    } else {
      setCurrentStep(0);
      setProdutoAI(null);
      setLoading(false);
      setError(null);
    }

    return () => {
      isCancelled = true;
      clearInterval(timer);
    };
  }, [open, searchDescricao]);

  const renderContent = () => {
    if (error) return <ErrorProdutoAI error={error} />;
    if (produtoAI?.ncm) return <ProdutoAI produtoAI={produtoAI} />;
    if (loading) {
      return (
        <AnimationFindProdutoAI
          currentStep={currentStep}
          steps={steps}
          loading={loading}
        />
      );
    }
    return null;
  };

  return (
    <Dialog
      id="container-filtro"
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "0.9rem",
          background: "white",
        },
      }}
    >
      <Box className="py-2 px-3 d-flex flex-column h-100">
        <CardHeader
          id="cabecalhoFiltroRelatorio"
          title={
            <Box className="d-flex align-items-center gap-2">
              <Box className="d-flex align-items-center gap-1">
                {Array(3)
                  .fill()
                  .map((_, i) => (
                    <Box
                      key={i}
                      className="rounded-pill"
                      sx={{
                        width: 3 * i + 2.5,
                        height: 20,
                        background: alpha(palette.primary.main, 0.2 * i + 0.2),
                      }}
                    />
                  ))}
              </Box>
              <Box>
                Inteligência Fiscal
                <Typography variant="body2" color="textSecondary">
                  {searchDescricao}
                </Typography>
              </Box>
            </Box>
          }
          sx={{ margin: "8px 0px -16px 0px !important" }}
        />
        <CardContent className="h-100">{renderContent()}</CardContent>
        <CardActions
          sx={{
            width: "100%",
            justifyContent: "space-between",
            marginBottom: "15px !important",
          }}
        >
          <Button
            variant="contained"
            className="fw-bold rounded-3"
            sx={{ width: "48%", textTransform: "capitalize" }}
            disableElevation
            color="padrao"
            onClick={() => handleClose()}
          >
            {produtoAI ? "Cancelar" : "Fechar"}
          </Button>
          <Button
            variant="contained"
            color="primary"
            className="fw-bold rounded-3"
            sx={{ width: "48%", textTransform: "capitalize" }}
            onClick={() => handleAplicarSugestaoAi(produtoAI, handleClose)}
            disableElevation
            disabled={!produtoAI?.ncm}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10, color: "#fff" }}
            ></i>
            Aplicar sugestão
          </Button>
        </CardActions>
      </Box>
    </Dialog>
  );
}
